<div class="row justify-content-center">
  <div class="col-12 col-lg-10 col-xl-8">

    <div class="text-left">
      <h2>Vous avez été invité à rejoindre une organisation ! Veuillez accepter une invitation pour rejoindre cette
      organisation.</h2>
    </div>

    <hr>

      <div class="row">
        <div class="col-12">

          <div class="card">
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col">

                  <!-- Title -->
                  <h4 class="card-header-title">
                    Invitations
                  </h4>

                </div>
                <div class="col-auto">
                  @if (this.isLoading) {
                    <span class="text-muted me-3"><i class="fas fa-sync fa-spin"></i> Actualisation en cours</span>
                  }
                  @if (this.showHasBeenRefreshed) {
                    <span class="text-muted me-3">Actualisé</span>
                  }

                  <a (click)="refresh(); $event.preventDefault()" class="btn btn-link" href="">
                    Actualiser
                  </a>

                </div>
              </div> <!-- / .row -->
            </div>
            <div class="table-responsive mb-0"
              data-list="{&quot;valueNames&quot;: [&quot;goal-project&quot;, &quot;goal-status&quot;, &quot;goal-progress&quot;, &quot;goal-date&quot;]}">
              <table class="table table-sm table-nowrap card-table">
                <thead>
                  <tr>
                    <th>
                      <a class="text-muted list-sort">
                        Organisation
                      </a>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                <tbody class="list">
                  @for (invite of invites; track invite) {
                    <tr class="table-row">
                      <td>
                        {{ invite.organizationName }}
                      </td>
                      <td>
                        <button (click)="acceptInvite(invite)" class="btn btn-primary btn-sm"> Accepter</button>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </div> <!-- / .row -->

    </div>
  </div> <!-- / .row -->